import React, { Component } from 'react'
import '../style.css'
import Swal from 'sweetalert2'

export default class Pay extends Component {
    handleAlert = () =>{
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-success m-2',
                cancelButton: 'btn btn-danger m-2'
            },
            buttonsStyling: false
        })

        swalWithBootstrapButtons.fire({
            title: 'Are you sure?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Place it',
            cancelButtonText: 'No, cancel!',
            reverseButtons: true 
        }).then((result) => {
            if (result.isConfirmed) {
                swalWithBootstrapButtons.fire(
                    'Done',
                    'Wait Our delivery call',
                    'success'
                )
            } else if (
                /* Read more about handling dismissals below */
                result.dismiss === Swal.DismissReason.cancel
            ) {
                swalWithBootstrapButtons.fire(
                    'Cancelled',
                    'Your Order still in Your cart ',
                    'error'
                )
            }
        })
    }
    render() {
        return (
            <React.Fragment>
                <div className="alert alert-success">
                    <div className="container">
                        <div className="content">
                            <div className="cont">
                                <div className="image">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-person-fill" viewBox="0 0 16 16">
                                        <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                                    </svg>
                                </div>
                                <div className="text">
                                    <div className="con">
                                        <h1>Customer : </h1>
                                        <h3>{this.props.info.name}</h3>
                                    </div>
                                    <div className="con">
                                        <h1>Email : </h1>
                                        <h3>{this.props.info.email}</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="cont">
                                <div className="image">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-truck" viewBox="0 0 16 16">
                                        <path d="M0 3.5A1.5 1.5 0 0 1 1.5 2h9A1.5 1.5 0 0 1 12 3.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-3.998-.085A1.5 1.5 0 0 1 0 10.5v-7zm1.294 7.456A1.999 1.999 0 0 1 4.732 11h5.536a2.01 2.01 0 0 1 .732-.732V3.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .294.456zM12 10a2 2 0 0 1 1.732 1h.768a.5.5 0 0 0 .5-.5V8.35a.5.5 0 0 0-.11-.312l-1.48-1.85A.5.5 0 0 0 13.02 6H12v4zm-9 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
                                    </svg>
                                </div>
                                <div className="text">
                                    <h1>Order info</h1>
                                    <div className="conten">
                                        <div className="inf">
                                            <h3>Shipping :</h3>
                                            <h3>{this.props.shipping}$</h3>
                                        </div>
                                        <div className="inf">
                                            <h3>Pay method :</h3>
                                            <h3><span>Offline</span></h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="cont">
                                <div className="image">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="22" fill="currentColor" className="bi bi-geo-alt-fill" viewBox="0 0 16 16">
                                        <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
                                    </svg>
                                </div>
                                <div className="text">
                                    <h1>Deliver to</h1>
                                    <h3>{this.props.info.Governorate} , {this.props.info.country} , {this.props.info.city}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="pay-pro">
                    <div className="container">
                        <div className="content">
                            <div className="left">
                                <div className="conten">
                                    {this.props.products.filter(f => f.isInCart === true).map(p => (
                                        <div className="cont" key={p.id}>
                                            <div className="left">
                                                <div className="image">
                                                    <img src={p.imgUrl} alt={p.name} />
                                                </div>
                                                <div className="name">
                                                    <h3>{p.name}</h3>
                                                </div>
                                            </div>
                                            <div className="right">
                                                <div className="con">
                                                    <h4>Quantity</h4>
                                                    <h6>{p.count}</h6>
                                                </div>
                                                <div className="con">
                                                    <h4>Subtotal</h4>
                                                    <h6>{`${p.price * p.count}`}</h6>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="right">
                                <table className="table table-success table-striped">
                                    <tbody>
                                        <tr>
                                            <td>Products</td>
                                            <td>{this.props.totalPrice}$</td>
                                        </tr>
                                        <tr>
                                            <td>Shipping</td>
                                            <td>{this.props.shipping}$</td>
                                        </tr>
                                        <tr>
                                            <td>Tax</td>
                                            <td>{this.props.tax}$</td>
                                        </tr>
                                        <tr>
                                            <td>Total</td>
                                            <td>{`${this.props.totalPrice + this.props.shipping + this.props.tax}`}$</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className="button">
                                    <button onClick={this.handleAlert}>Place Order</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
